export interface VisibilityOptions {
  rootMargin?: string;
  onChange(visible: boolean): void;
}

export function visibility(node: HTMLElement, options: VisibilityOptions) {
  if (typeof IntersectionObserver === 'undefined') {
    options.onChange(true);
    return { destroy() {} };
  }
  const observer = new IntersectionObserver((entries) => {
    options.onChange(entries.some((entry) => entry.isIntersecting));
  }, { rootMargin: options.rootMargin ?? '700px 0px' });
  observer.observe(node);
  return { destroy: () => observer.disconnect() };
}

